import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'

const usePopulatedCarrierServices = ({ storeId, parcelCarrier }) => {
  const { data: carrierServices, loading: fetchingCarriers } = useFetch(commonServices.getCarrierServices, {
    doInitialRequest: true,
    params: { storeId, type: 'shipment' },
  })

  const getCarrierServices = () => {
    let carriers = []

    if (carrierServices?.length) carriers = [...carrierServices]

    if (parcelCarrier) carriers.unshift(parcelCarrier)

    return carriers
  }

  return {
    carrierServices: getCarrierServices(),
    fetchingCarriers,
  }
}

export default usePopulatedCarrierServices
